module.exports = __webpack_public_path__ + "static/media/pagamentoefetuado.e2b906d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/pagamentoefetuado.svg
// module id = 2244
// module chunks = 2